module.exports = __webpack_public_path__ + "static/media/19ESCAP48.4ee0a3c7.jpg";